import React, { createRef } from 'react'
import { connect } from 'react-redux'
import { Row, Col } from 'react-flexbox-grid'
import { searchAI, searchErrorSubmit, searchAILoadMore, resetResponse, pushFolder, getProjects, pushElement, pushFeedback, getFeedbacks, delFeedback } from '../../actions/actionCreators'
import { Message,  Loader, Image, Segment, Header, Button, Icon, Sticky, Ref } from 'semantic-ui-react'
import SearchResult from './result'
import SearchBar from './bar'
import SearchFilters from './filters'
import _ from 'lodash'
import Logo from '../../images/logo-admin.png'
import ModalDialog from './modalDialog'
import { Text, Translate, LanguageContext } from '../../helpers/language';
import { backendService } from '../../services/backendService'


const resultsTypes = [
  { type: 'principle'},
  { type: 'synthetic_principle'},
]

const queryTypes = [  
  'TYPE_PRINCIPLE',
  'TYPE_VERDICT'
]

class Search extends React.Component {
  contextRef = createRef()

  constructor(props) {
    super(props)

    const availableYears = this.computeAvailableYears()
    this.handleSearchQueryChanged = this.handleSearchQueryChanged.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.handleClick = this.handleClick.bind(this)
    this.handleFilter = this.handleFilter.bind(this)
    this.handleFilterButton = this.handleFilterButton.bind(this)
    this.handleReset = this.handleReset.bind(this)
    this.createFolder = this.createFolder.bind(this)
    this.handleClearArea = this.handleClearArea.bind(this)
    this.handleFiltersAccordition = this.handleFiltersAccordition.bind(this)
    this.createFeedback = this.createFeedback.bind(this)
    this.deleteFeedback = this.deleteFeedback.bind(this)
    this.addElement = this.addElement.bind(this)
    this.search = this.search.bind(this)
    this.load_more = this.load_more.bind(this)
    this.printResult = this.printResult.bind(this);
    this.submitError = this.submitError.bind(this)
    this.getFeedbacks = this.getFeedbacks.bind(this)

    this.state = {
      loading: this.props.loading,
      free_trial_expired: this.props.free_trial_expired,
      loadingMore: this.props.loadingMore,
      showMessage: false,
      selectedCategory: 'law',
      activeIndex: -1,
      lastQueries: [],
      offsets: [],
      showErrorMessage: false,
      results: [],
      folders: [],
      customer: {},
      yearDoc: [],
      selectedType: 1, // 0 = authoral principles, 1 = synthetic principles
      selectedArea: 0,
      selectedAreaText: undefined,
      selectedAreaFilterValue: [],
      searchedYr: _.map(availableYears, (yr, i) => ({
        key: yr,
        text: yr,
        value: yr,
      })),
      searchedType: [
        {
          key: 'sentenza',
          text: 'search_type_verdict',
          value: 'sentenza',
        },
        {
          key: 'massima',
          text: 'search_type_rule',
          value: 'massima',
        }
      ],
      searchedArea: [
        {
          key: 1,
          text: 'search_area_court',
          value: 1,
          filterValue: [3]
        },
        {
          key: 2,
          text: 'search_area_tribunals',
          value: 2,
          filterValue: [1,2]
        }
      ],
      filtered: false,
      searchQueryValue: '',
      authorities: undefined,
      noSearchFoundMessage: false,
      filtersAccorditionActive: false,
      activeFilters: { years: [], area: undefined}
    }    
    
    for (let i = 0 ; i < resultsTypes.length; ++i) {
      this.state.results.push([])
      this.state.offsets.push(0)
      this.state.lastQueries.push('')
    }
  }

  computeAvailableYears() {
    const now = new Date()
    let curYear = now.getFullYear()
    let availableYears = []
    while (curYear >= 2000) {
      availableYears.push(curYear) 
      curYear--
    }
    return availableYears
  }

  saveStateToLocalStorage() {
    try {

      let results = []
      if (this.state.results) {
        results = this.state.results
      }
      sessionStorage.setItem('lastQueries', JSON.stringify(this.state.lastQueries));
      sessionStorage.setItem('offsets', JSON.stringify(this.state.offsets));
      sessionStorage.setItem('results', JSON.stringify(results));
      sessionStorage.setItem('yearDoc', typeof this.state.yearDoc === 'undefined' ? '[]' : JSON.stringify(this.state.yearDoc));
      sessionStorage.setItem('selectedType', typeof this.state.selectedType === 'undefined' ? JSON.stringify(0) : JSON.stringify(this.state.selectedType));      
      sessionStorage.setItem('selectedArea', typeof this.state.selectedArea === 'undefined' ? 0 : this.state.selectedArea);
      sessionStorage.setItem('selectedAreaText', typeof this.state.selectedAreaText === 'undefined' ? '' : this.state.selectedAreaText);
      sessionStorage.setItem('filtered', JSON.stringify(this.state.filtered));
      sessionStorage.setItem('searchQueryValue', this.state.searchQueryValue);
      sessionStorage.setItem('folders', JSON.stringify(this.state.folders));
      sessionStorage.setItem('customer', JSON.stringify(this.state.customer));

    } catch (exc) {
      console.error(exc)
    }
  }

  async hydrateStateWithLocalStorage() {
    if (sessionStorage.lastQueries) {
      this.setState({ lastQueries: JSON.parse(sessionStorage.getItem('lastQueries')) });
    }

    if (sessionStorage.offsets) {
      this.setState({ offsets: JSON.parse(sessionStorage.getItem('offsets')) });
    }

    if (sessionStorage.results) {
      await this.setState({ results: JSON.parse(sessionStorage.getItem('results')) });      
    } else {      
      let principles = []
    //0 = principles, 1 = synthetic principles
    for (let i = 0 ; i < resultsTypes.length; ++i) {
      principles.push([])
    }
      this.setState({ results: principles });
    }
    // START SPECIAL
    if (sessionStorage.yearDoc && sessionStorage.yearDoc.length > 1) {
      this.setState({ yearDoc: JSON.parse(sessionStorage.getItem('yearDoc')) });
    }

    if (sessionStorage.selectedType) {
      this.setState({ selectedType: JSON.parse(sessionStorage.getItem('selectedType')) });
    }

    if (sessionStorage.selectedArea) {
      this.setState({ selectedArea: parseInt(sessionStorage.getItem('selectedArea')) });
    }

    if (sessionStorage.selectedAreaText && sessionStorage.selectedAreaText.length > 1) {
      this.setState({ selectedAreaText: sessionStorage.getItem('selectedAreaText') });
    }
    // END SPECIAL
    if (sessionStorage.filtered) {
      this.setState({ filtered: JSON.parse(sessionStorage.getItem('filtered')) });
    }

    if (sessionStorage.folders) {
      this.setState({ folders: JSON.parse(sessionStorage.getItem('folders')) });
    }

    if (sessionStorage.customer) {
      this.setState({ customer: JSON.parse(sessionStorage.getItem('customer')) });
    }

    if (sessionStorage.searchQueryValue) {
      this.setState({ searchQueryValue: sessionStorage.getItem('searchQueryValue') });
    }

  }

  componentWillUnmount() {
    window.removeEventListener(
      "beforeunload",
      this.saveStateToLocalStorage.bind(this)
    );

    // saves if component has a chance to unmount
    this.saveStateToLocalStorage();    
  }

  componentDidMount() {

    window.dataLayer.push({
      event: 'page_view',
      page: {
        url: document.location.pathname,
        title: 'Search'
      }
    });

    window.scrollTo(0, 0);

    if (typeof this.props.location.state != 'undefined') {
      let off = []
      let queries = []
      for (let i = 0 ; i < resultsTypes.length; ++i) {          
        off.push(0)
        queries.push('')
      }
      this.setState({ searchQueryValue: this.props.location.state.queryToReSearch, 
                      lastQueries: queries, 
                      offsets: off, 
                      filtered: false, 
                      yearDoc: [], 
                      selectedType: this.props.location.state.selectedType ? this.props.location.state.selectedType : 0, 
                      selectedArea: 0, 
                      selectedAreaText: undefined 
                    }, () => {
        
        this.props.dispatch(getProjects({ user: this.props.auth.user.email, userId: this.props.auth.user.id })).then(() => { this.setState({folders: this.props.projects, customer: this.props.customerProfile}); this.search() })
      })
    }
    else {
      this.hydrateStateWithLocalStorage();
      this.props.dispatch(getProjects({ user: this.props.auth.user.email, userId: this.props.auth.user.id})).then(() => {this.setState({folders: this.props.projects, customer: this.props.customerProfile})})
    }

    // add event listener to save state to sessionStorage
    // when user leaves/refreshes the page
    window.addEventListener(
      "beforeunload",
      this.saveStateToLocalStorage.bind(this)
    );
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.search.loading === false) {
      this.setState({ activeIndex: -1 })
    }
  }

  async componentDidUpdate(prevProps) {
    try {
      if (prevProps.loadingMore && prevProps.loadingMore !== this.props.loadingMore) {
        console.log('loading more results...')
        if (this.props.loading === true)     
          await this.setState({loadingMore: this.props.loadingMore})  
        let results = this.reorderData(this.props.search)
        await this.getFeedbacks(results)
        let outArticles = JSON.parse(JSON.stringify(this.state.results))
        outArticles[this.state.selectedType] = outArticles[this.state.selectedType].concat(results[this.state.selectedType])
        await this.setState({ state: this.state, results: outArticles });
        if (this.props.loading === false)     
          await this.setState({loadingMore: this.props.loadingMore})  
      } else if (prevProps.loading && prevProps.loading !== this.props.loading) {
        console.log('loading new results...') 
        if (this.props.loading === true)     
          await this.setState({loading: this.props.loading})  
        let results = this.reorderData(this.props.search)        
        await this.getFeedbacks(results)
        let outArticles = JSON.parse(JSON.stringify(this.state.results))
        outArticles[this.state.selectedType] = results[this.state.selectedType]
        await this.setState({ results: outArticles });
        if (results[this.state.selectedType].length === 0) {
          console.log('Didn\'t load any result')
          this.setState({ noSearchFoundMessage: true });          
          this.setState({ activeIndex: -1 });
        } else {
          this.setState({ noSearchFoundMessage: false });
          this.setState({ activeIndex: -1 });
        }
        if (this.props.loading === false) {  
          if (this.props.free_trial_expired)
            window.location.reload();
          else
            await this.setState({loading: this.props.loading})
        }
      }
    } catch (exc) {
      console.error(exc)
    }
  }

  async getFeedbacks(results) {
    let targetIds = []
    if (results[this.state.selectedType] && results[this.state.selectedType].length > 0) {
      targetIds = results[this.state.selectedType].map(cur => cur.id_new)
    }
    if (targetIds.length > 0) {
        let resp = await backendService.post(`/api/feedbacks/search?user=${this.props.auth.user.email}`, { ids: targetIds })
        if (resp && resp.data) {
          resp.data.forEach(curFeedback => {
            let result = results[this.state.selectedType].find(element => element.id_new === curFeedback.idResult)      
            if (result) {
              result.feedback = curFeedback.positive ? 'positive': 'negative'                        
            }
          }); 
        }
        
    } 
  }

  handleChange = (e, { value }) => {
    this.props.dispatch(resetResponse())
    this.setState({ selectedCategory: value }, () => {
      if (this.state.searchQueryValue && this.state.searchQueryValue.length > 0) {
        this.search()
      }
    })
  }

  handleSearchQueryChanged = (e) => {
    this.setState({ searchQueryValue: e.target.value })
  }

  handleClick = (e, titleProps, callback) => {
    const { index } = titleProps
    const { activeIndex } = this.state
    const newIndex = activeIndex === index ? -1 : index
    this.setState({ activeIndex: newIndex })
    if (callback) {
      callback(newIndex === index)
    }
  }

  hideMessage() {
    setTimeout(() => { this.setState({ showMessage: false }) }, 3000)
  }

  reorderData(data) {

    let principles = []
    //0 = principles, 1 = synthetic principles
    for (let i = 0 ; i < resultsTypes.length; ++i) {
      principles.push([])
    }
    
    Object.values(data).map((item, i) => {
      if (item.document_type_massima === 0 || item.document_type_massima === 1) {
        principles[item.document_type_massima].push(item)
      }      
    })
    return principles
  }

  loader() {
    return (
      <Row>
        <Col xs={12} className='pad20'>
          <div className="cssload-loader">
            <div className="cssload-inner cssload-one"></div>
            <div className="cssload-inner cssload-two"></div>
            <div className="cssload-inner cssload-three"></div>
          </div>
        </Col>
      </Row>
    )
  }

  submitError() {
    this.props.dispatch(searchErrorSubmit()) 
   }

  /*
   * load more results
   */
  load_more() {
    let off = this.state.offsets
    off[this.state.selectedType] = off[this.state.selectedType] + 10
    this.setState({ offsets: off ,
                    loadingMore: true
                  }, () => {
      let filters = {selectedType: this.state.selectedType === 0 ? 'massima': 'sentenza'}
      if (this.state.yearDoc.length > 0) 
        filters.yearDoc = this.state.yearDoc
      if (this.state.selectedArea !== 0) 
        filters.selectedArea = this.state.selectedArea
      
      this.props.dispatch(searchAILoadMore({
        query: this.state.lastQueries[this.state.selectedType],
        category: this.state.selectedCategory,
        size: 10,
        offset: this.state.offsets[this.state.selectedType],
        maxscore: this.state.results[this.state.selectedType].real_score,
        filters
        
      }))
    })
  }

  /*
   * execute search 
   */
  do_search() {    
      //set filters
      let filters = {selectedType: this.state.selectedType === 0 ? 'massima': 'sentenza'}
      if (this.state.yearDoc.length > 0) 
        filters.yearDoc = this.state.yearDoc
      if (this.state.selectedArea !== 0) 
        filters.selectedArea = this.state.selectedArea

      this.props.dispatch(searchAI({
        query: this.state.searchQueryValue,
        category: this.state.selectedCategory,
        size: 10,
        question: { query: this.state.searchQueryValue, user: this.props.auth.user.email, query_type: queryTypes[this.state.selectedType] },
        auth: this.props.auth,
        token: this.props.auth.token,
        filters
      }))    
  }

  /*
   * prepare search 
   */
  search() {
    this.setState({activeFilters: { years: this.state.yearDoc, area: this.state.selectedArea}}, () => {
      if (this.state.searchQueryValue && this.state.searchQueryValue.length > 0) {      
        let queries = this.state.lastQueries
        queries[this.state.selectedType] = this.state.searchQueryValue
        this.setState(
          { 
            lastQueries: queries, 
            offset: 0, 
            filtered: false, 
            yearDoc: [],                       
            selectedArea: 0, 
            selectedAreaText: undefined,
            loading: true
          }, 
            () => {
              this.do_search()
            })        
      }
    })
    
  }

  /**
   * execute search with filters 
   */
  filter_search() {
    this.setState({activeFilters: { years: this.state.yearDoc, area: this.state.selectedArea}}, () => {
      if (this.state.searchQueryValue && this.state.searchQueryValue.length > 0) {      
        this.setState(
          { 
            filtered: true,
            loading: true
          }, 
          () => {
            this.props.location.state = undefined
            this.do_search()
          }
        ) 
      }
    })
  }
  /**
   * user feedback creation
   * @param {*} idSite 
   * @param {*} result 
   * @param {*} positive 
   * @param {*} query 
   * @param {*} comment 
   * @param {*} callback 
   */
  createFeedback = (idSite, result, positive, query, comment, callback) => {
    this.props.dispatch(pushFeedback({
      user: this.props.auth.user.email,
      idResult: idSite,
      query: query,
      result: result,
      positive: positive,
      comment: comment
    })).then(() => { callback() })
  }
  /**
   * delete user feedback
   * @param {*} idSite 
   * @param {*} callback 
   */
  deleteFeedback = (idSite, callback) => {
    this.props.dispatch(delFeedback({
      user: this.props.auth.user.email,
      idResult: idSite
    })).then(() => { callback() })
  }
  
  /**
   * get user feedback
   * @param {*} idSite 
   * @param {*} callback 
   */
  getSentFeedbacks = (idSite, callback) => {
    this.props.dispatch(getFeedbacks({
      user: this.props.auth.user.email,
      idResult: idSite
    })).then(() => { callback() })
  }

  /**
   * create user project 
   * @param {*} folderName 
   * @param {*} description 
   * @param {*} result 
   * @param {*} idSite 
   * @param {*} callback 
   */
  createFolder = (folderName, description, result, idSite, callback) => {
    this.props.dispatch(pushFolder({
      user: this.props.auth.user.email,
      name: folderName,
      description: description,
      projectelement: { user: this.props.auth.user.email, name: folderName, idResult: idSite, result: result, query: this.state.searchQueryValue }
    })).then(() => {
      if (this.props.success == false) {
        this.setState({ showErrorMessage: true })

        const self = this
        setTimeout(function () {
          self.setState({ showErrorMessage: false })
        }, 3000)
      }
      else {
        this.props.dispatch(getProjects({ user: this.props.auth.user.email, userId: this.props.auth.user.id})).then(() => { this.setState({ folders: this.props.projects, customer: this.props.customerProfile }); callback(folderName) })
      }
    })
  }
  /**
   * add current result to folder
   * @param {*} projectId 
   * @param {*} folderName 
   * @param {*} result 
   * @param {*} idSite 
   * @param {*} callback 
   */
  addElement = (projectId, folderName, result, idSite, callback) => {
    this.props.dispatch(pushElement({ projectId,
      projectelement: { idResult: idSite, result: result, query: this.state.searchQueryValue },
    })).then(() => { callback(folderName) })
  }

  /**
   * document type change between authoral principles/synthetic principles
   *  
   * 
   * @param {*} e 
   * @param {*} data 
   */
  handleDocumentTypeChange(e, data) {
    this.setState({loading: true})
    let alreadySearched = this.state.lastQueries[this.state.selectedType] === this.state.searchQueryValue
    this.setState({ selectedType: data }, () =>  {
        if (alreadySearched && this.state.lastQueries[this.state.selectedType] !== this.state.searchQueryValue) {
          this.search()
        } else {
          this.setState({loading: false})   
        }
      }
    )
  }

  /**
   * handle area changed
   * @param {*} e 
   * @param {*} data 
   */
  handleAreaChange(e, data) {
    let selectedAreaElement = ''
    let value = data.value ? data.value : undefined
    if (value)
      for (var i in this.state.searchedArea) {
        if (this.state.searchedArea[i].key === data.value) {
          selectedAreaElement = Translate(this.context, this.state.searchedArea[i].text)
        }
      }

    this.setState({ selectedArea: value, selectedAreaText: selectedAreaElement })
  }

  /**
   * handle year changed
   * @param {*} e 
   * @param {*} data 
   */
  handleYrChange(e, data) {
    this.setState({ yearDoc: data })
  }

  /**
   * handle filters changed
   * @param {*} e 
   * @param {*} data 
   */
  handleFilter(e, data) {
    let off = this.state.offsets
    off[this.state.selectedType] = 0
    this.setState({ offsets: off }, () => {
      this.filter_search()
    })
  }

  /**
   * handle filter button pressed
   * @param {*} e 
   * @param {*} data 
   */
  handleFilterButton(e, data) {
    let off = this.state.offsets
    off[this.state.selectedType] = 0
    this.setState({ offsets: off }, () => {
      this.filter_search()
    })
  }
  
 /**
  * filter reset
  * @param {*} e 
  * @param {*} data 
  */
  handleReset(e, data) {
    this.setState({ filtered: false, selectedArea: 0, selectedAreaText: undefined, yearDoc: [] }, () => {
      this.search()
    })
  }

  handleClearArea() {
    this.setState({ selectedArea: 0, selectedAreaText: undefined })
  }

  handleFiltersAccordition() {
    const active = this.state.filtersAccorditionActive === true ? false : true
    this.setState({ filtersAccorditionActive: active })
  }

  printResult(index, type) {
    let content_div_id = 'content_result_' + index;
    let carousel_div_id = 'massima_carousel_' + index;
    let heading_div_id = 'result_heading_' + index; 
    let docType = type ? type : 0;
    let heading = document.getElementById(heading_div_id);
    if( heading != null) {
      heading = heading.innerHTML
    }
    let contents = document.getElementById(content_div_id);
    if( contents != null) {
      //remove close button form printed document
      const element = contents.querySelector('div[id^=return_button]')
      if (element)
        element.parentNode.removeChild(element);
      contents = contents.innerHTML
    }
    console.log(contents)
    let carousel = document.getElementById(carousel_div_id);
    if( carousel != null) {
      carousel = carousel.innerHTML
    }
    let frame1 = document.createElement('iframe');
    frame1.name = "frame1";
    frame1.style.position = "absolute";
    frame1.style.top = "-1000000px";
    document.body.appendChild(frame1);
    let frameDoc = frame1.contentWindow ? frame1.contentWindow : frame1.contentDocument.document ? frame1.contentDocument.document : frame1.contentDocument;
    frameDoc.document.open();
    frameDoc.document.write('<html><head><title>LISIA</title>');
    frameDoc.document.write('</head><body>');
    if (heading) {
      frameDoc.document.write('<h4>' + heading + '</h4>') ;     
    }
    if( carousel != null ) {
      if (docType === 0) {
        frameDoc.document.write('<b>' + Translate(this.context, 'search_rule_heading') + '</b><br><br>');
      } else {
        frameDoc.document.write('<b>' + Translate(this.context, 'search_synthetic_rule_heading') + '</b><br><br>');
      }
      frameDoc.document.write('<div>' + carousel + '</div>') ;      
    }
    if (contents) {
      frameDoc.document.write('<hr />') ;
      frameDoc.document.write('<b>' + Translate(this.context, 'result_full_verdict_capital') + '</b><br><br>');
      frameDoc.document.write('<div>' + contents + '</div>');
    }
    frameDoc.document.write('</body></html>');
    
    frameDoc.document.close();
    setTimeout(function () {
      window.frames["frame1"].focus();
      window.frames["frame1"].print();
      document.body.removeChild(frame1);
    }, 500);
    return false;
  }


render() {
  const searchedArea = [
    {
      key: 1,
      text: Translate(this.context,'search_area_court'),
      value: 1,
    },
    {
      key: 2,
      text: Translate(this.context,'search_area_tribunals'),
      value: 2,
    }
  ]
  
  //const selectedCategory = this.state.selectedCategory !== '' ? this.state.selectedCategory : 'law'
  //const selectedTypeText = this.state.selectedTypeText
  const yearDoc = this.state.yearDoc
  const selectedMassima = this.state.selectedMassima
  const selectedSentenza = this.state.selectedSentenza
  const selectedArea = this.state.selectedArea
  const selectedAreaText = this.state.selectedAreaText
  const activeFilters = this.state.activeFilters
  const iconStyle = {
    position: 'absolute',
    top: 0,
    bottom: 0,
    margin: 'auto',
    right: '2.5em',
    lineHeight: 1,
    zIndex: 1,
  }

  const containerStyle = {
    position: 'relative'
  }
  return (
    <Ref innerRef={this.contextRef}>
    <div className='search-content' >      
      <Col xs={10} sm={4} md={3} className='lisia-app-search-logo-wrapper'>
        <Image src={ Logo } />
      </Col>      
      <Col xs={12} md={10} className='searchBarContainer'>      
        <Sticky context={this.contextRef} >
            <SearchBar 
              do_search={this.search}              
              handleSearchQueryChanged={this.handleSearchQueryChanged}              
              query={this.state.searchQueryValue}
            />
        </Sticky>    
        <SearchFilters 
          handleTabChange={this.handleDocumentTypeChange.bind(this)}
          activeTabIndex={this.state.selectedType}
          disabled={this.state.loading || this.state.loadingMore}
        />    
      </Col>      

      {(!this.props.query || !this.props.license) &&
      <ModalDialog
        type='warning'
        header={Translate(this.context, !this.props.license ? 'subscription_expired' : 'subscription_no_queries')}  
        body={Translate(this.context, 'subscription_manage_body')}  
        dispatch={this.props.dispatch}    
        onOk={ async () => { window.location = '/subscription' }}
        onCancel={ async () => this.props.dispatch(searchErrorSubmit()) }  
        negativeButtonText={Translate(this.context, 'cancel')}
        positiveButtonText={Translate(this.context, 'subscription_manage')}
      />
      }
      {this.state.loading &&
        <Col className='centered' xs={12} md={10}>
          {this.loader()}
        </Col>
      }
      {!this.state.loading && this.props.result && this.props.search && (!this.state.results || !this.state.results[this.state.selectedType] || this.state.results[this.state.selectedType].length === 0) && this.state.noSearchFoundMessage === true &&
        <Col className='centered' xs={12} md={10}>
          <Col xs={12} md={12}>
            <Segment className='noResultsSegment'>
              <Header icon>
                <Icon name='search' />
                <Text tid='search_no_results'/>
                </Header>
              {this.state.filtered === true &&
                <div>
                  <Header as='h5'>
                  <Text tid='search_reset_filters'/>
                    </Header>
                  <Button color='vk' onClick={this.handleReset}><Text tid='search_reset_filters_button'/></Button>
                </div>
              }
            </Segment>
          </Col>
        </Col>
      }
      {!this.state.loading && this.props.result && this.props.search && this.state.results && this.state.results[this.state.selectedType] && this.state.results[this.state.selectedType].length > 0 &&
        <Col xs={12} md={10} className='centered'>

          { /* TODO filters disabled on 2020/10/05 
          <Accordion className='filtersAccordion'>
            <Accordion.Title
              active={this.state.filtersAccorditionActive}
            >

              <Grid columns={2} stretched className='filtersGrid'>
                <Grid.Column width={8}>                  
                </Grid.Column>
                <Grid.Column width={8} className='filtraBtn'>
                  <Button icon labelPosition='right' onClick={this.handleFiltersAccordition} className='buttonFiltraRisultati'>
                      <Text tid='search_filters_title'/>
                      <Icon name='filter' />
                  </Button>
                </Grid.Column>
              </Grid>
            </Accordion.Title>
            <Accordion.Content active={this.state.filtersAccorditionActive}>


              <Col xs={12} md={12}>
                <Segment>
                  <div className="pad20">
                    <Grid stretched stackable columns='equal' verticalAlign='top'>
                      <Grid.Row>
                        <Grid.Column >
                          <Header as='h5'><Text tid='search_authority'/></Header>
                          <div style={containerStyle}>                            
                            <Dropdown
                              placeholder={Translate(this.context, 'search_filters_authority')}
                              onChange={(e, data) => { this.handleAreaChange(e, data) }}
                              fluid
                              clearable
                              selection
                              label={Translate(this.context, 'search_authority')}
                              value={selectedArea ? selectedArea: null}
                              options={searchedArea}                              
                            />
                          </div>
                          {' '}
                        </Grid.Column>
                        <Grid.Column>
                          <Header as='h5'><Text tid='search_year'/></Header>
                          <Dropdown
                            placeholder={Translate(this.context, 'search_filters_year')}
                            noResultsMessage=''
                            onChange={(e, data) => { this.handleYrChange(e, data.value) }}
                            value={yearDoc}
                            text={Translate(this.context, 'search_filters_year')}
                            fluid
                            search
                            multiple
                            selection
                            options={this.state.searchedYr}
                          />
                        </Grid.Column>
                        <Grid.Column largeScreen={3} widescreen={2} width={4} style={{paddingTop: '30px'}}>                          
                          <Button
                            className='lisia-blue search-filter-button'
                            icon='filter'
                            labelPosition='right'
                            onClick={this.handleFilter}
                            disabled={ ((yearDoc === activeFilters.years || yearDoc.length === 0) && activeFilters.years.length === 0) && selectedArea === activeFilters.area }

                          >
                            <Text tid='search_filter_button'/>
                            <Icon name='filter' />
                          </Button>
                        </Grid.Column>
                      </Grid.Row>
                    </Grid>
                  </div>
                </Segment>
              </Col>


            </Accordion.Content>
          </Accordion>    */}   

          <Col xs={12} md={12}>
            {this.state.showErrorMessage &&
              <Message
                warning
                header={Translate(this.context, 'search_folder_exists')}
              />
            }
            < div className='search_results_wrapper'>
              {this.state.results[this.state.selectedType].map((result, i) => {
                return (
                  <SearchResult
                    key={'response-' + i}
                    activeIndex={this.state.activeIndex}
                    handleClick={this.handleClick}
                    createFolder={this.createFolder}
                    addElement={this.addElement}
                    result={result}
                    article_type={'law'}
                    i={i}
                    createFeedback={this.createFeedback}
                    deleteFeedback={this.deleteFeedback}                    
                    query={this.state.searchQueryValue}
                    getSentFeedbacks={this.getSentFeedbacks}
                    printResultFnc={this.printResult}                   
                  />
                )
              })
              }
            </div>
          </Col>

          {this.state.offsets[this.state.selectedType] <= 40 && !this.state.loadingMore &&
            <Col xs={12} md={12}>
              <Button className='marginLoadMore lisia-blue' onClick={this.load_more} fluid><Text tid='search_load_more'/></Button>
            </Col>
          }

          {this.state.loadingMore &&
            <Loader active inline='centered' className='marginLoadMore' />
          }



        </Col>
      }
    </div>
    </Ref>
  )
}
}

const mapStateToProps = (state) => ({
  auth: state.auth,
  search: state.search && state.search.data ? state.search.data : [],
  authorities: state.search && state.search.aut ? state.search.aut : [],
  loading: state.search.loading !== undefined ? state.search.loading : false,
  result: state.search.result !== undefined ? state.search.result : false,
  free_trial_expired: state.search.free_trial_expired !== undefined ? state.search.free_trial_expired : false,
  loadingMore: state.search.loadingMore !== undefined ? state.search.loadingMore : false,
  projects: state.articles.projects !== undefined ? state.articles.projects : [],
  customerProfile: state.articles.customerProfile !== undefined ? state.articles.customerProfile : {},
  success: state.articles.success !== undefined ? state.articles.success : true,
  searchAccess: state.search.access !== undefined ?  state.search.access : true,
  query: state.search.query !== undefined ?  state.search.query : true,
  license: state.search.license !== undefined ?  state.search.license : true
})

Search.contextType = LanguageContext;

export default connect(mapStateToProps)(Search)
